import IMG from "/images/founder.jpg"

const Founder = () => {
  return (
    <section name="founder" className="py-6 lg:py-10 px-5 lg:px-25 bg-light-olive/10 font-montserrat">
      <h1 className="text-black font-semibold text-2xl lg:text-3xl text-center mb-3 lg:mb-6">
        Founder's Story
      </h1>

      <div className="lg:grid lg:grid-cols-12 gap-10">

        {/* Image (Right on Laptop) */}
        <div className="lg:col-span-4 flex justify-center lg:order-last">
          <img
            src={IMG}
            className="lg:w-80 w-30 h-30 lg:h-80 rounded-full mb-2 lg:mb-0"
          />
        </div>

        {/* Text Section */}
        <div className="lg:col-span-8 space-y-4 text-sm lg:text-base text-dark-gray">
          <p>
            Patrick Taylor (he/him) is a Doctor of Social Work student at USC, a licensed 
            clinical social worker, and an Air Force veteran. His story is rooted in 
            frustration: despite social work’s immense potential to address society’s 
            biggest challenges, the profession has been systematically funneled into 
            clinical roles.
          </p>

          <p>
            Taylor’s own journey reflects this imbalance. Drawn to social work by the 
            promise of systemic change, he found himself steered into clinical practice, 
            graduating without the macro training he had hoped for. Seven years later, 
            he carries the weight of that gap, not as a personal failing, but as evidence 
            of a decades-old pattern. That experience drives his mission: dismantling 
            The Micro Pipeline in Social Work (MPISW) and building new pathways that 
            prepare and empower social workers to lead change at the systems level.
          </p>

          <p>
            Through Macro Pathways, Taylor is advancing the Grand Challenge of 
            “Creating social responses to a changing environment.” He envisions a 
            profession where social workers are not just responders but proactive 
            shapers of policy, community, and organizational systems. His purpose 
            is clear: to equip future social workers with the tools, confidence, 
            and opportunities they need to reclaim the profession’s true identity 
            as a force for systemic change.
          </p>
        </div>

      </div>
    </section>
  )
}

export default Founder
